const SITE_DATA = {
    brand: {
        name: 'KANGA',
        tagline: 'Keeping Australia\'s national greatness alive.',
        established: '2026'
    },

    currentDrop: {
        id: 'drop-001',
        name: 'AUSFIRST#001',
        subtitle: 'FOUNDATIONS',
        theme: 'the origin',
        story: `Before there was a movement, there was a foundation. AUSFIRST#001 represents the beginning — pieces forged from the essence of this land. Each item carries the weight of Australian identity, crafted for those who understand what it means to stand firm on their own ground. This is not clothing. This is a manifesto worn on the body.`,
        status: 'COMING SOON'
    },

    upcomingReleases: [
        {
            id: 'drop-002',
            name: 'KANGA #002',
            subtitle: 'CLASSIFIED',
            theme: '█████ ████████',
            status: 'LOCKED',
            locked: true
        },
        {
            id: 'drop-003',
            name: 'KANGA #003',
            subtitle: 'CLASSIFIED',
            theme: '█████ ████████',
            status: 'LOCKED',
            locked: true
        }
    ],

    pastReleases: [
        {
            id: 'drop-000',
            name: 'DROP 000',
            subtitle: 'PROTOTYPE',
            theme: 'Before the movement began.',
            releaseDate: 'DECEMBER 2025',
            status: 'ARCHIVED',
            pieces: 4,
            story: 'The prototype collection. Four experimental pieces that set the tone for everything that followed. This drop tested the identity, the craft, and the commitment. It will never be re-released. If you have it, you were there at the start.',
            products: [
                { name: 'PROTOTYPE HOODIE', status: 'ARCHIVED' },
                { name: 'ORIGIN TEE', status: 'ARCHIVED' },
                { name: 'FOUNDATION CAP', status: 'ARCHIVED' },
                { name: 'SIGNAL SHORTS', status: 'ARCHIVED' }
            ],
            gradient: 'linear-gradient(135deg, #0a0a0a 0%, #1c1010 100%)'
        }
    ],

    products: [
        {
            id: 'straya-longsleeve-light',
            name: 'STRAYA LONGSLEEVE — LIGHT GREY',
            price: 110,
            drop: 'drop-001',
            tag: null,
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/light-GREY-LON-SLEEVE-AUS-FIRST_jpg.jpg?v=1779850530',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/light-GREY-LON-SLEEVE-AUS-FIRST_jpg.jpg?v=1779850530',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/light-GREY-LONG_SLEEVE-AUS-FIRST.jpg?v=1779946509'
            ],
            story: 'Wear the country on your chest. The Straya Longsleeve in light grey is the everyday piece — versatile enough for anything, bold enough to make a statement.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'RELAXED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #2a2a2a 0%, #3a3a3a 40%, #484848 100%)'
        },
        {
            id: 'straya-longsleeve-dark',
            name: 'STRAYA LONGSLEEVE — DARK GREY',
            price: 110,
            drop: 'drop-001',
            tag: null,
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/dark-grey-STRAYA-LONG-SLEEVE-GREY-2_jpg.jpg?v=1779850532',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/dark-grey-STRAYA-LONG-SLEEVE-GREY-2_jpg.jpg?v=1779850532',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/dark-greySTRAYA-LONG-SLEEVE-GREY-1_jpg.jpg?v=1779850532'
            ],
            story: 'The darker edge. Same Straya DNA, deeper shade — dark grey marle that means business. Southern Cross front and centre.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'RELAXED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #111 0%, #1e1e1e 40%, #2a2a2a 100%)'
        },
        {
            id: 'southern-cross-tee',
            name: 'WHITE AUS SHIRT TEE',
            price: 85,
            drop: 'drop-001',
            tag: 'BESTSELLER',
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/WHITE-AUS-FIRST-1_jpg.jpg?v=1779850532',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/WHITE-AUS-FIRST-1_jpg.jpg?v=1779850532',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/WHITE-AUS-FIRST-2_jpg.jpg?v=1779850530',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/Product-2-Aus-first-tshirt-white_jpg.jpg?v=1779850533'
            ],
            story: 'Clean white. Bold statement. The Southern Cross Tee puts the whole country on your chest — map, stars, and all. 100% cotton, fitted cut, no compromise.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'FITTED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #1c1c1c 0%, #2c2c2c 40%, #3a3a3a 100%)'
        },
        {
            id: 'navy-aus-first-longsleeve',
            name: 'NAVY AUS FIRST TEE',
            price: 120,
            drop: 'drop-001',
            tag: 'LIMITED',
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-1_1_jpg.jpg?v=1779850532',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-1_1_jpg.jpg?v=1779850532',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-1_JPG.jpg?v=1779850532',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-1_2_jpg.jpg?v=1779850532',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-2_jpg.jpg?v=1779850531',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-AUS-FIRST-3_jpg.jpg?v=1779850530'
            ],
            story: 'Navy base, bold statement. The Navy Aus First Longsleeve is built for those who wear their identity without apology.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'RELAXED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #080818 0%, #101028 40%, #181840 100%)'
        },
        {
            id: 'navy-aus-flag-longsleeve',
            name: 'NAVY AUS FLAG LONGSLEEVE',
            price: 120,
            drop: 'drop-001',
            tag: null,
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-LON-SLEEVE-AUS-FLAG_jpg.jpg?v=1779850532',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/NAVY-LON-SLEEVE-AUS-FLAG_jpg.jpg?v=1779850532'
            ],
            story: 'The flag on your chest, the country on your back. Navy longsleeve with full Australian flag — no subtlety, no apology.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'REGULAR', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #08101e 0%, #101828 40%, #182038 100%)'
        },
        {
            id: 'commonwealth-tee',
            name: 'AUS GREY TEE',
            price: 80,
            drop: 'drop-001',
            tag: null,
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/gREY-SHIRT-AUS-FLAG-1_JPG.jpg?v=1779850534',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/gREY-SHIRT-AUS-FLAG-1_JPG.jpg?v=1779850534',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/gREY-SHIRT-AUS-FLAG-2_jpg.jpg?v=1779850534'
            ],
            story: 'The Commonwealth Tee is simple and direct. Grey marle, fitted cut, Australian flag front and centre. No explanation needed.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'FITTED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #1a1a1a 0%, #282828 40%, #363636 100%)'
        },
        {
            id: 'heritage-crewneck',
            name: 'AUS EMBROIDERED JUMPER',
            price: 160,
            drop: 'drop-001',
            tag: 'PREMIUM',
            image: 'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/EMBROIDERED-AUS-FLAG-JUMPER_jpg.jpg?v=1779850531',
            images: [
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/EMBROIDERED-AUS-FLAG-JUMPER_jpg.jpg?v=1779850531',
                'https://cdn.shopify.com/s/files/1/0637/6806/8193/files/EMBROIDERED-AUS-FLAG-JUMPER-2_jpg.jpg?v=1779850531'
            ],
            story: 'Built to last generations. The Heritage Crewneck is an oversized statement in dark olive — the flag on the chest, the weight on the shoulders. 400GSM fleece.',
            sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            stats: { FIT: 'OVERSIZED', ORIGIN: 'AU DESIGNED' },
            gradient: 'linear-gradient(145deg, #0d1208 0%, #1a2010 40%, #222a14 100%)'
        }
    ],

    territories: {
        WA: {
            name: 'WESTERN AUSTRALIA',
            fullName: 'Western Australia',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Western Australia is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        NT: {
            name: 'NORTHERN TERRITORY',
            fullName: 'Northern Territory',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Northern Territory is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        QLD: {
            name: 'QUEENSLAND',
            fullName: 'Queensland',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Queensland is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        SA: {
            name: 'SOUTH AUSTRALIA',
            fullName: 'South Australia',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'South Australia is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        NSW: {
            name: 'NEW SOUTH WALES',
            fullName: 'New South Wales',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'New South Wales is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        VIC: {
            name: 'VICTORIA',
            fullName: 'Victoria',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Victoria is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        TAS: {
            name: 'TASMANIA',
            fullName: 'Tasmania',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Tasmania is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        },
        ACT: {
            name: 'AUSTRALIAN CAPITAL TERRITORY',
            fullName: 'Australian Capital Territory',
            status: 'ACTIVE',
            drop: 'AUSFIRST#001 — FOUNDATIONS available now',
            description: 'Australian Capital Territory is fully active. Complete access to all AUSFIRST#001 pieces.',
            color: '#ffffff'
        }
    }
};
